import { jsx, jsxs } from "react/jsx-runtime";
import { Tabs } from "@zillow/constellation-10";
import { v8ResponsiveToPanda, triggerTabClickEvent } from "@zillow/zrs-cms";
import { isPlainObject } from "lodash";
import React, { useRef, useState, useEffect } from "react";
import { generateBlockList } from "../../components/BlockList/BlockList.esm.js";
function getTabFromHash(innerBlocks) {
  if (typeof window === "undefined") return void 0;
  const hash = window.location.hash.slice(1);
  if (!hash) return void 0;
  const matchingBlock = innerBlocks.find((block) => block.attrs.id === hash);
  return matchingBlock == null ? void 0 : matchingBlock.attrs;
}
function updateUrlHash(id) {
  if (typeof window === "undefined" || !id) return;
  const url = new URL(window.location.href);
  url.hash = id;
  window.history.replaceState(null, "", url.toString());
}
function scalarValue(value) {
  if (isPlainObject(value)) {
    const obj = value;
    return obj.default ?? obj.lg_lte ?? obj.sm_lte;
  }
  return value;
}
function mapResponsive(value, fn) {
  if (isPlainObject(value)) {
    const out = {};
    Object.entries(value).forEach(([k, v]) => {
      out[k] = fn(v);
    });
    return out;
  }
  return fn(value);
}
const HtmlToReact = require("html-to-react");
const HtmlToReactParser = require("html-to-react").Parser;
const htmlToReactParser = new HtmlToReactParser();
const processNodeDefinitions = new HtmlToReact.ProcessNodeDefinitions(React);
const processingInstructions = [{
  shouldProcessNode() {
    return true;
  },
  processNode: processNodeDefinitions.processDefaultNode
}];
const TabsBlock = ({
  attrs,
  index,
  innerBlocks
}) => {
  const containerRef = useRef(null);
  const scalarFluid = scalarValue(attrs.fluid) ?? false;
  const fluidPanda = isPlainObject(attrs.fluid) ? v8ResponsiveToPanda(attrs.fluid) : void 0;
  const indicatorRadiusCss = {
    _selected: {
      _before: {
        borderStartStartRadius: "obj.default",
        borderStartEndRadius: "obj.default"
      }
    }
  };
  const tabCss = fluidPanda ? {
    ...indicatorRadiusCss,
    flexBasis: mapResponsive(fluidPanda, (v) => v ? "0" : "auto"),
    flexGrow: mapResponsive(fluidPanda, (v) => v ? "1" : "0"),
    justifyContent: mapResponsive(fluidPanda, (v) => v ? "center" : "flex-start")
  } : indicatorRadiusCss;
  const listCss = attrs.justifyContent ? {
    justifyContent: isPlainObject(attrs.justifyContent) ? v8ResponsiveToPanda(attrs.justifyContent) : attrs.justifyContent
  } : void 0;
  const tabs = [];
  const panels = [];
  innerBlocks.forEach((innerBlock) => {
    const {
      tabId
    } = innerBlock.attrs;
    tabs.push(/* @__PURE__ */ jsx(Tabs.Tab, { value: tabId, css: tabCss, children: htmlToReactParser.parseWithInstructions(innerBlock.attrs.label, () => true, processingInstructions) }, tabId));
    panels.push(/* @__PURE__ */ jsx(Tabs.Panel, { value: tabId, children: generateBlockList({
      blocks: innerBlock.innerBlocks
    }) }, tabId));
  });
  const initialTabId = attrs.defaultSelectedId || innerBlocks[0].attrs.tabId;
  const [selectedTabId, setSelectedTabId] = useState(initialTabId);
  useEffect(() => {
    const hashTab = getTabFromHash(innerBlocks);
    if (hashTab) {
      setSelectedTabId(hashTab.tabId);
      requestAnimationFrame(() => {
        var _a;
        (_a = containerRef.current) == null ? void 0 : _a.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      });
    }
  }, []);
  return /* @__PURE__ */ jsx("div", { ref: containerRef, children: /* @__PURE__ */ jsxs(Tabs.Root, { appearance: attrs.appearance, fluid: scalarFluid, selected: selectedTabId, onSelectedChange: (tabId) => {
    const tabInnerBlock = innerBlocks.find((innerBlock) => innerBlock.attrs.tabId === tabId);
    if (!tabInnerBlock) {
      return;
    }
    setSelectedTabId(tabId);
    updateUrlHash(tabInnerBlock.attrs.id);
    triggerTabClickEvent({
      id: tabInnerBlock.attrs.id,
      label: tabInnerBlock.attrs.label
    });
  }, id: attrs.id, children: [
    /* @__PURE__ */ jsx(Tabs.List, { css: listCss, children: tabs }),
    panels
  ] }, index) });
};
export {
  TabsBlock as default
};
